<template>
  <nav aria-label="Pagination">
    <ul class="flex justify-end items-center gap-3 my-5">
      <!-- Previous Button -->
      <li>
        <button
          @click="changePage(currentPage - 1)"
          :disabled="currentPage === 1"
          class="px-4 py-2 text-sm rounded border border-gray-300 bg-white hover:bg-gray-100 transition-all disabled:opacity-60 disabled:cursor-not-allowed"
        >
          Previous
        </button>
      </li>

      <!-- Page Numbers -->
      <li v-for="page in paginatedPages" :key="page">
        <button
          v-if="page !== '...'"
          @click="changePage(page)"
          :disabled="page === currentPage"
          class="px-4 py-2 text-sm rounded border transition-all"
          :class="
            page === currentPage
              ? 'bg-secondary text-white border-secondary cursor-not-allowed'
              : 'bg-white border-gray-300 hover:bg-gray-100'
          "
        >
          {{ page }}
        </button>
        <span v-else class="px-4 py-2 text-sm text-gray-500"> ... </span>
      </li>

      <!-- Next Button -->
      <li>
        <button
          @click="changePage(currentPage + 1)"
          :disabled="currentPage === totalPages"
          class="px-4 py-2 text-sm rounded border border-gray-300 bg-white hover:bg-gray-100 transition-all disabled:opacity-60 disabled:cursor-not-allowed"
        >
          Next
        </button>
      </li>
    </ul>
  </nav>
</template>

<script>
import { computed, defineComponent, toRefs } from "vue";

export default defineComponent({
  props: {
    totalPages: {
      type: Number,
      required: true,
    },
    currentPage: {
      type: Number,
      required: true,
    },
  },
  setup(props, { emit }) {
    const { totalPages, currentPage } = toRefs(props);

    const paginatedPages = computed(() => {
      const pages = [];
      const range = 2;

      for (let i = 1; i <= totalPages.value; i++) {
        if (
          i <= range ||
          i > totalPages.value - range ||
          (i >= currentPage.value - range && i <= currentPage.value + range)
        ) {
          pages.push(i);
        } else if (pages[pages.length - 1] !== "...") {
          pages.push("...");
        }
      }

      return pages;
    });

    const changePage = (page) => {
      if (page > 0 && page <= totalPages.value) {
        emit("update:currentPage", page);
      }
    };

    return {
      paginatedPages,
      changePage,
    };
  },
});
</script>
